/*
 * Border-radius scale. Theme-agnostic.
 */
export const radius = {
    none: '0',
    xs: '0.25rem', // 4px
    sm: '0.375rem', // 6px
    md: '0.5rem', // 8px
    lg: '0.625rem', // 10px
    xl: '0.875rem', // 14px
    '2xl': '1.25rem', // 20px
    full: '9999px',
} as const

export type Radius = typeof radius
